import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

// TODO: use same icon as explorer (add to common icon lib)
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import Tooltip from '@mui/material/Tooltip';

import MapButton from './map-button';
import {modes, setMode} from '../actions/ui';

const CompareButton = ({setMode, active}) => {
  const handleClick = () => setMode(!active ? modes.COMPARE : modes.NONE);

  return (
    <Tooltip title="Compare Basemaps" placement="left">
      <span>
        <MapButton active={active} data-qe="compare-tool" onClick={handleClick}>
          <SwapHorizIcon />
        </MapButton>
      </span>
    </Tooltip>
  );
};

CompareButton.propTypes = {
  active: PropTypes.bool.isRequired,
  setMode: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setMode,
};

const mapStateToProps = ({ui}) => ({
  active: ui.mode === modes.COMPARE,
});

export default connect(mapStateToProps, mapDispatchToProps)(CompareButton);
